@if (faqData()) {
  <div
    class="px-8 py-16 md:py-24"
    [ngClass]="{
      'bg-ss-darker-brown text-white': brownBg,
      'bg-ss-www-background text-white': faqData().darkBackground && !brownBg,
      'bg-white !text-ss-brown': !faqData().darkBackground && !brownBg,
    }"
  >
    <h2
      class="text-center lg:mb-4"
      [ssDirectus]="{
        collection: 'faqs',
        item: faqData().id,
        fields: ['title'],
      }"
    >
      {{ faqData().title }}
    </h2>
    @if (faqData().textBlock) {
      <div class="-mt-6 mb-4">
        <ss-www-text-block
          [textBlockData]="faqData().textBlock!"
          [lastBlock]="false"
        ></ss-www-text-block>
      </div>
    }
    <ss-accordion class="max-w-4xl mx-auto">
      @for (item of qAndAs(); track $index) {
        <ss-accordion-item [customId]="item.id">
          <h4
            ssAccordionItemTitle
            class="tracking-wider"
            [ssDirectus]="{
              collection: 'faqQuestions',
              item: item.id,
              fields: ['question'],
            }"
          >
            {{ item.question }}
          </h4>
          <div
            class="px-4 pb-4"
            [innerHTML]="item.answer"
            [ssDirectus]="{
              collection: 'faqQuestions',
              item: item.id,
              fields: ['answer'],
            }"
          ></div>
          <hr ssAccordionItemDivider />
        </ss-accordion-item>
      }
    </ss-accordion>
    <div
      class="text-center mb-4 mt-6 mx-auto max-w-4xl"
      [innerHTML]="faqData().footer"
      [ssDirectus]="{
        collection: 'faqs',
        item: faqData().id,
        fields: ['footer'],
      }"
    ></div>
    <div
      class="flex flex-row grow flex-wrap justify-center gap-4 mx-auto max-w-4xl"
    >
      @for (button of faqData().footerButtons; track buttons($index, button)) {
        <ss-building-block-button-link
          [buttonLink]="button.item"
          class="flex-1 md:flex-initial"
        ></ss-building-block-button-link>
      }
    </div>
  </div>
}
